import React from 'react';
import { CircularProgress } from '@mui/material';

// TODO: Cambiar a Skeleton
const FingoTableLoader = () => <CircularProgress />;

export default FingoTableLoader;
